import { RemoveButton } from "components/Common/CustomButtons/CustomButtons";

function RemoveColButton({
  col,
  setTradeData,
  isTradeRequestFire,
  isRequestsActive,
}) {
  return (
    <RemoveButton
      disabled={isTradeRequestFire === null || isRequestsActive}
      style={{
        width: "40px",
        height: "30px",
        marginLeft: "20px",
      }}
      onClick={() => {
        setTradeData((prev) => {
          return {
            data: {
              ...prev.data,
              trades: [
                ...prev.data.trades.filter(
                  (el) => el.column_id !== col.column_id
                ),
              ],
            },
          };
        });
      }}
    />
      
  );
}

export default RemoveColButton
